export type SalesOverviewResponse = {
  metrics: {
    totalOrders: number;
    paidOrders: number;
    pendingOrders: number;
    thisMonthRevenue: number;
    outstandingBalance: number;
    customersWithOrders: number;
    activeCoupons: number;
    lowStockProducts: number;
  };
  dailySeries: Array<{
    dayKey: string;
    dayLabel: string;
    paidRevenue: number;
    paidOrders: number;
  }>;
  paymentMix: Array<{
    paymentType: string;
    totalOrders: number;
    collectedAmount: number;
  }>;
  recentOrders: Array<{
    id: number;
    addedOn: string | null;
    customerName: string;
    phone: string;
    total: number;
    amountPaid: number;
    balance: number;
    status: string;
    paymentType: string;
    trackingNumber: string;
  }>;
  recentCustomers: Array<{
    id: number;
    name: string;
    phone: string;
    email: string;
    lastOrderOn: string | null;
    orderCount: number;
  }>;
  activeCoupons: Array<{
    id: number;
    code: string;
    description: string;
    discount: number;
    maxDiscount: number;
    type: "PERCENTAGE" | "FIXED";
    expiryDate: string | null;
    usageCount: number;
  }>;
};

export async function fetchSalesOverview() {
  const response = await fetch("/api/sales/overview", {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data as SalesOverviewResponse;
}
